<template>
  <Select v-bind="$attrs" v-on="$listeners" :translationPath="'statusses'">
    <template #item="{ item }">
      <BaseStatus :status="item.value || item" />
    </template>
    <template #selection="{ item }">
      <BaseStatus :status="item.value || item" />
    </template>
  </Select>
</template>

<script>
export default {
  name: 'StatusSelect',
}
</script>